export default {
  addResourceId: (state, payload) => {
    const resourceAlreadySaved = state.resourceIdList.find(el => el.id === payload)
    if (!resourceAlreadySaved) {
      state.resourceIdList.push(payload)
    }
  },
  addResource: (state, payload) => {
    const resourceAlreadySaved = state.resources.find(el => el.id === payload.id)
    if (!resourceAlreadySaved) {
      state.resources.push({ id: payload.id, resource: payload.resource })
    }
  },
  removeResources: (state) => {
    if (state.resources.length > 0) {
    state.resources.forEach((resource) => {
      URL.revokeObjectURL(resource.src)
    })
    }
    state.resourceIdList = []
    state.resources = []
  },
  removeResource: (state, payload) => {
    const resource = state.resources.find(el => el.id === payload)
    if (resource) {
      URL.revokeObjectURL(resource.src)
      state.resources = state.resources.filter(el => el.id !== payload)
    }
  }

}
